<div class="flex flex-col bg-surface-50 dark:bg-surface-950 h-full overflow-hidden">
    <div class="flex flex-col gap-3 p-3 flex-1 min-h-0 overflow-hidden">
        <div class="grid grid-cols-1 lg:grid-cols-4 gap-3 h-full">
            <!-- Tag Types Section -->
            <div class="lg:col-span-1 shadow rounded-base p-3 border flex flex-col gap-3 min-h-0">
                <div class="flex flex-col gap-2 h-full overflow-hidden">
                    <div class="flex flex-col gap-2 flex-shrink-0">
                        <div class="flex items-center justify-between">
                            <div class="text-surface-900 dark:text-surface-0 font-semibold text-lg">Tag Types</div>
                            <div class="block sm:hidden">
                                <app-button variant="outlined" severity="contrast" icon="pi pi-upload"
                                    (clicked)="openUploadExcelDialog()" pTooltip="Upload Excel" tooltipPosition="top" />
                            </div>
                        </div>

                        <div class="flex flex-col gap-2">
                            <!-- Show full buttons on desktop, icon-only on mobile (moved to top for mobile) -->
                            <div>
                                <app-button variant="outlined" severity="contrast" (clicked)="openUploadExcelDialog()"
                                    class="w-full" [label]="'Upload Excel'" [icon]="icons.MS_EXCEL" iconSource="svg"
                                    iconSize="lg" />
                            </div>
                            <div>
                                <app-button variant="filled" severity="primary" label="Add" icon="pi pi-plus"
                                    class="w-full" (clicked)="handleClickAddTag()" />
                            </div>
                        </div>
                    </div>

                    <div class="items-center">
                        <app-search-bar placeholder="Search Tag Type" [(ngModel)]="searchTagTypes"
                            (searchChange)="onTagTypesSearchChange()" [disabled]="tagTypeLoading">
                        </app-search-bar>
                    </div>

                    <div #tagTypesContainer class="overflow-y-auto flex-1 min-h-0 no-scrollbar"
                        (scroll)="onTagTypesScroll()">
                        @if(tagTypeLoading){
                        @for (item of getSkeletonCount(6); track $index) {
                        <div class="w-full h-20 pt-2">
                            <p-skeleton width="100%" height="90%" />
                        </div>
                        }
                        }
                        @else{
                        @if(!filteredTagTypes.length) {
                        <div
                            class="flex flex-col items-center justify-center text-center text-sm text-gray-600 py-6 min-h-[30vh]">
                            @if (searchTagTypes && searchTagTypes.trim().length > 0) {
                            <div class="flex flex-col items-center gap-1">
                                <img [src]="'images/empty_search_innform.svg' | assetUrl"
                                    class="w-40 h-40 object-contain" alt="No Result">
                                <div class="text-lg font-semibold">No Results Found!</div>
                                <div>There are no tag types with the word <strong>{{ searchTagTypes }}</strong></div>
                            </div>
                            } @else {
                            <div class="flex flex-col items-center gap-1">
                                <img [src]="'images/empty_search_innform.svg' | assetUrl"
                                    class="w-40 h-40 object-contain" alt="No Tag Types">
                                <div class="text-lg font-semibold">No Tag Types Found</div>
                            </div>
                            }
                        </div>
                        }
                        @for (keyPoint of filteredTagTypes; track keyPoint._id) {
                        <div [id]="'tag-type-' + keyPoint._id"
                            class="flex flex-row gap-2 border p-3 my-2 justify-between rounded-base items-center cursor-pointer min-w-0"
                            [class.disabled-key-point]="blockedDataTypesToShowAddButton.includes(keyPoint.dataType)"
                            [class.active-key-point]="selectedTagType?._id === keyPoint._id"
                            (click)="selectKeyPoint(keyPoint)">
                            <div class="flex flex-row gap-2 items-center min-w-0 flex-1">
                                <span class="border px-2 py-1 rounded-base key-point-icon flex-shrink-0">
                                    <i class="{{getTagTypeIcon(keyPoint.tagType, keyPoint.dataType)}}"></i>
                                </span>
                                <span class="font-bold truncate block min-w-0" [pTooltip]="keyPoint.name"
                                    tooltipPosition="top" [showDelay]="500">{{keyPoint.name}}</span>
                            </div>
                            <app-popover #popover [width]="'auto'" [showScrollbar]="false">
                                <ng-template #trigger>
                                    <div class="flex justify-center pointer-events-auto flex-shrink-0">
                                        <i class="pi pi-ellipsis-v cursor-pointer"></i>
                                    </div>
                                </ng-template>
                                <ng-template #body>
                                    <div class="flex flex-col gap-1">
                                        <div class="flex items-center p-2 hover:bg-gray-100 rounded cursor-pointer"
                                            (click)="handleTagMenuClick($event, 'Edit', keyPoint); popover.hide()">
                                            <span class="pi pi-pencil"></span>
                                            <span class="ml-2">Edit</span>
                                        </div>
                                        <div class="flex items-center p-2 hover:bg-gray-100 rounded cursor-pointer text-danger"
                                            (click)="handleTagMenuClick($event, 'Delete', keyPoint); popover.hide()">
                                            <span class="pi pi-trash"></span>
                                            <span class="ml-2">Delete</span>
                                        </div>
                                    </div>
                                </ng-template>
                            </app-popover>
                        </div>
                        }
                        @if(isFetchingMore && !tagTypeLoading){
                        <div class="flex justify-center items-center py-4">
                            <p-skeleton width="60%" height="1.5rem"></p-skeleton>
                        </div>
                        }
                        }
                    </div>
                </div>
            </div>

            <!-- Client Tags Section -->
            <div class="lg:col-span-3 flex flex-col gap-3 min-h-0 h-full max-h-[calc(100vh-23.125rem)] md:max-h-none">
                <div class="flex items-center justify-between gap-3 flex-shrink-0">
                    <div class="flex flex-col sm:flex-row items-start sm:items-center gap-2 flex-1 min-w-0">
                        <div class="text-surface-900 dark:text-surface-0 font-semibold text-lg">
                            {{selectedTagType?.name}} Tags
                            <span class="text-surface-500 dark:text-surface-400">({{filterTags.length}})</span>
                        </div>
                        @if(selectedTagType) {
                        <app-search-bar class="w-full sm:w-auto" placeholder="Search Tag" [(ngModel)]="searchValue"
                            (ngModelChange)="onFilter()" width="100%"></app-search-bar>
                        }
                    </div>
                    <div class="flex gap-2"
                        *ngIf="allowedTagTypesToShowAddButton.includes(selectedTagType?.tagType!) && !blockedDataTypesToShowAddButton.includes(selectedTagType?.dataType!)">
                        <app-button variant="outlined" severity="contrast" (clicked)="openUploadTagsExcelDialog()"
                            [label]="'Upload Excel'" [icon]="icons.MS_EXCEL" iconSource="svg" iconSize="lg"
                            pTooltip="Upload Excel" tooltipPosition="top" />
                        <app-button variant="filled" severity="primary" label="Add" icon="pi pi-plus"
                            (clicked)="addTag()" />
                    </div>
                </div>

                <div class='flex-1 min-h-0 overflow-y-auto scrollbar-thin'>
                    <div [ngClass]="!isSmallScreen? 'flex flex-col gap-2':'flex flex-col gap-2 mb-2'">
                        @if(tagLoading){
                        @for (item of getSkeletonCount(5); track $index) {
                        <div class="w-full h-20 pt-2">
                            <p-skeleton width="100%" height="90%" />
                        </div>
                        }
                        }
                        @else{
                        @if(!filterTags.length) {
                        <div
                            class="flex flex-col items-center justify-center text-center text-sm text-gray-600 py-6 min-h-[40vh]">
                            @if (searchValue && searchValue.trim().length > 0) {
                            <div class="flex flex-col items-center gap-1">
                                <img [src]="'images/empty_search_innform.svg' | assetUrl"
                                    class="w-40 h-40 object-contain" alt="No Result">
                                <div class="text-lg font-semibold">No Results Found!</div>
                                <div>There are no tags with the word <strong>{{ searchValue }}</strong></div>
                            </div>
                            } @else {
                            <div class="flex flex-col items-center gap-1">
                                <img [src]="'images/empty_search_innform.svg' | assetUrl"
                                    class="w-40 h-40 object-contain" alt="No Tags">
                                <div class="text-lg font-semibold">No Tags Found</div>
                                <div>Start by adding tags to organize your content</div>
                            </div>
                            }
                        </div>
                        }
                        @for (tag of filterTags; track tag._id; let i = $index) {
                        <p-card class="tag-card border rounded-base">
                            <div class="flex flex-col md:flex-row gap-3 justify-between items-start md:items-center">
                                <div class="w-full  md:column-60">
                                    <div class="flex flex-row gap-3 items-center">
                                        <span class="flex-shrink-0">
                                            <i class="{{TAG_TYPES_ICONS[selectedTagType?.tagType!]}}"></i>
                                        </span>
                                        <span class="flex flex-col min-w-0 w-full flex-1">
                                            @if(tag.id){
                                            <div class="flex flex-col gap-2">
                                                <div class="flex flex-row gap-2">
                                                    <span class="font-bold break-words">{{tag.name}} ({{tag.id
                                                        }})</span>
                                                </div>
                                                @if(tag.description){
                                                <span class="truncate-text-responsive" [pTooltip]="tag.description"
                                                    tooltipPosition="top">{{tag.description}}</span>
                                                }
                                            </div>
                                            }@else{
                                            <span class="font-bold break-words">{{tag.name }}</span>
                                            <span class="text-gray-500 break-words">{{tag.address}}</span>
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div class="w-full md:column-40 justify-end flex items-center ">
                                    <div
                                        class="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between md:justify-start">
                                        <div class="flex justify-between gap-2 items-center">
                                            <app-user-name-display [user]="tag.createdBy"
                                                [variant]="'avatar-name'"></app-user-name-display>
                                        </div>
                                        <span class="flex flex-row gap-2">
                                            <app-button variant="outlined" severity="contrast" icon="pi pi-pencil"
                                                (clicked)="editTag(tag)" pTooltip="Edit" tooltipPosition="left" />
                                            <app-button variant="outlined" severity="danger" icon="pi pi-trash"
                                                (clicked)="deleteTag(tag)" pTooltip="Delete" tooltipPosition="bottom" />
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </p-card>
                        }
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

@if(deleteTagDialogVisible){
<app-delete-confirmation [(visible)]="deleteTagDialogVisible" headerText="Are you sure?"
    bodyText="Do you want to delete this tag?" confirmButtonText="Proceed" (onConfirm)="confirmDeleteTag()">
</app-delete-confirmation>
}

@if(deleteTagTypeDialogVisible){
<app-delete-confirmation [(visible)]="deleteTagTypeDialogVisible" headerText="Are you sure?"
    bodyText="Do you want to delete this tag type?" confirmButtonText="Proceed" (onConfirm)="confirmDeleteTagType()">
</app-delete-confirmation>
}

<app-dialog [(visible)]="tagAddDialogVisible" [title]="(editTagTypeDialog ? 'Edit' : 'Add') + ' Tag Type'"
    (closed)="tagAddDialogVisible = false" class="max-w-[640px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <form [formGroup]="tagTypeForm">
            <div class="flex flex-col gap-3 p-4">
                <div class="flex flex-col gap-2">
                    <label for="name" class="text-sm font-medium">
                        Name<span class="text-danger">*</span>
                    </label>
                    <input id="name" formControlName="name" placeholder="Enter tag type name" autocomplete="off"
                        class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500" />
                    <div *ngIf="tagTypeFormControls['name'].invalid && (tagTypeFormControls['name'].dirty || tagTypeFormControls['name'].touched)"
                        class="text-danger text-xs">
                        {{"Name is required." | titlecase}}
                    </div>
                </div>
                <div class="flex flex-col gap-2">
                    <label for="description" class="text-sm font-medium">Description</label>
                    <textarea id="description" formControlName="description" placeholder="Enter description"
                        autocomplete="off" rows="3"
                        class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"></textarea>
                </div>
                <div class="flex flex-col gap-2">
                    <label for="dataType" class="text-sm font-medium">
                        Data Type<span class="text-danger">*</span>
                    </label>
                    <app-select [options]="dataTypeOptions" [config]="dynamicDataTypeConfig" formControlName="dataType">
                    </app-select>
                </div>
                @if(ENV.environment !== 'production') {
                <div class="flex flex-col gap-2">
                    <label for="feature" class="text-sm font-medium">
                        Project/Document Mapping<span class="text-danger">*</span>
                    </label>
                    <app-multi-select [options]="tagFeatureOptions" [config]="tagFeatureConfig"
                        formControlName="feature">
                    </app-multi-select>
                    <div *ngIf="tagTypeFormControls['feature'].invalid && (tagTypeFormControls['feature'].dirty || tagTypeFormControls['feature'].touched)"
                        class="text-danger text-xs">
                        {{"Project/Document Mapping is required." | titlecase}}
                    </div>
                </div>
                }
                @if(isDocumentFeatureSelected) {
                <div class="flex flex-col gap-2">
                    <label for="documentType" class="text-sm font-medium">Document Type</label>
                    <app-select [options]="documentTypeOptions" [config]="documentTypeConfig"
                        formControlName="documentType">
                    </app-select>
                </div>
                }
                <div class="flex flex-col gap-2">
                    <label for="mandatory" class="text-sm font-medium">Mandatory</label>
                    <app-toggle formControlName="mandatory" name="mandatory" inputId="mandatory" class="w-full">
                    </app-toggle>
                </div>
            </div>
        </form>
    </ng-template>
    <ng-template #footerTemplate>
        <app-button variant="filled" severity="primary" label="Add" icon="pi pi-plus" (clicked)="addTagType()"
            [enableThrottle]="true" />
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="tagDialogVisible"
    [title]="(isEditingTag ? 'Edit' : 'Add') + ' ' + (selectedTagType?.name || '') + ' Tag Type'"
    (closed)="tagDialogVisible = false" class="max-w-[640px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="p-4">
            <ng-container *ngTemplateOutlet="selectedTemplate"></ng-container>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end">
            <app-button variant="filled" severity="primary" label="Save" icon="pi pi-save" (clicked)="saveTag()"
                [enableThrottle]="true" />
        </div>
    </ng-template>
</app-dialog>

<ng-template #clientTemplate>
    @if (selectedTag ) {
    <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-2">
            <label for="name" class="text-sm font-medium">
                Name <span class="text-danger">*</span>
            </label>
            <input id="name" [(ngModel)]="selectedTag.name" placeholder="Enter client name" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #name="ngModel" />
            <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger text-xs">
                {{"Name is required." | titlecase}}
            </div>
        </div>
        <div class="flex flex-col gap-2">
            <label for="address" class="text-sm font-medium">
                Address
            </label>
            <textarea id="address" [(ngModel)]="selectedTag.address" placeholder="Enter address" autocomplete="off"
                rows="2"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"></textarea>
        </div>
        <div class="flex flex-col gap-2">
            <label for="licenseNumber" class="text-sm font-medium">
                License Number
            </label>
            <input id="licenseNumber" [(ngModel)]="selectedTag.licenseNumber" placeholder="Enter license number"
                autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500" />
        </div>
        <div class="flex flex-col gap-2">
            <label for="fax" class="text-sm font-medium">
                Fax
            </label>
            <input id="fax" [(ngModel)]="selectedTag.fax" placeholder="Enter fax number" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500" />
        </div>
        <div class="flex flex-col gap-2">
            <label for="website" class="text-sm font-medium">
                Website
            </label>
            <input id="website" [(ngModel)]="selectedTag.website" placeholder="Enter website URL" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500" />
        </div>
    </div>
    }
</ng-template>

<ng-template #locationTemplate>
    @if (selectedTag ) {
    <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-2">
            <label for="name" class="text-sm font-medium">
                Name <span class="text-danger">*</span>
            </label>
            <input id="name" [(ngModel)]="selectedTag.name" placeholder="Enter location name" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #name="ngModel" />
            <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger text-xs">
                {{"Name is required." | titlecase}}
            </div>
        </div>
        <div class="flex flex-col gap-2">
            <label for="address" class="text-sm font-medium">
                Address
            </label>
            <textarea id="address" [(ngModel)]="selectedTag.address" placeholder="Enter address" autocomplete="off"
                rows="2"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"></textarea>
        </div>
        <div class="flex flex-col gap-2">
            <label for="city" class="text-sm font-medium">
                City
            </label>
            <input id="city" [(ngModel)]="selectedTag.city" placeholder="Enter city" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #city="ngModel" />
        </div>
        <div class="flex flex-col gap-2">
            <label for="state" class="text-sm font-medium">
                State
            </label>
            <input id="state" [(ngModel)]="selectedTag.state" placeholder="Enter state" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #state="ngModel" />
        </div>
        <div class="flex flex-col gap-2">
            <label for="zip" class="text-sm font-medium">
                Zip
            </label>
            <input id="zip" [(ngModel)]="selectedTag.zip" placeholder="Enter zip code" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #zip="ngModel" />
        </div>
        <div class="flex flex-col gap-2">
            <label for="country" class="text-sm font-medium">
                Country
            </label>
            <input id="country" [(ngModel)]="selectedTag.country" placeholder="Enter country" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #country="ngModel" />
        </div>
    </div>
    }
</ng-template>

<ng-template #typeOfContractTemplate>
    @if (selectedTag ) {
    <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-2">
            <label for="name" class="text-sm font-medium">
                Name <span class="text-danger">*</span>
            </label>
            <input id="name" [(ngModel)]="selectedTag.name" placeholder="Enter contract type name" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #name="ngModel" />
            <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger text-xs">
                {{"Name is required." | titlecase}}
            </div>
        </div>
        <div class="flex flex-col gap-2">
            <label for="description" class="text-sm font-medium">
                Description
            </label>
            <textarea id="description" [(ngModel)]="selectedTag.description" placeholder="Enter description"
                autocomplete="off" rows="3"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"></textarea>
        </div>
    </div>
    }
</ng-template>

<ng-template #scopeOfWorkTemplate>
    @if (selectedTag ) {
    <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-2">
            <label for="name" class="text-sm font-medium">
                Name <span class="text-danger">*</span>
            </label>
            <input id="name" [(ngModel)]="selectedTag.name" placeholder="Enter scope of work name" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #name="ngModel" />
            <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger text-xs">
                {{"Name is required." | titlecase}}
            </div>
        </div>
        <div class="flex flex-col gap-2">
            <label for="description" class="text-sm font-medium">
                Description
            </label>
            <textarea id="description" [(ngModel)]="selectedTag.description" placeholder="Enter description"
                autocomplete="off" rows="3"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"></textarea>
        </div>
    </div>
    }
</ng-template>
<ng-template #customTemplate>
    @if (selectedTag ) {
    <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-2">
            <label for="value" class="text-sm font-medium">
                Value <span class="text-danger">*</span>
            </label>
            <input id="value" [(ngModel)]="selectedTag.name" placeholder="Enter value" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #value="ngModel" />
            <div *ngIf="value.invalid && (value.dirty || value.touched)" class="text-danger text-xs">
                {{"Value is required." | titlecase}}
            </div>
        </div>
    </div>
    }
</ng-template>

<ng-template #projectTemplate>
    @if (selectedTag ) {
    <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-2">
            <label for="projectId" class="text-sm font-medium">
                Project ID <span class="text-danger">*</span>
            </label>
            <input id="projectId" [(ngModel)]="selectedTag.id" placeholder="Enter project ID" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #id="ngModel" />
            <div *ngIf="id.invalid && (id.dirty || id.touched)" class="text-danger text-xs">
                {{"Project ID is required." | titlecase}}
            </div>
        </div>
        <div class="flex flex-col gap-2">
            <label for="name" class="text-sm font-medium">
                Name <span class="text-danger">*</span>
            </label>
            <input id="name" [(ngModel)]="selectedTag.name" placeholder="Enter project name" autocomplete="off"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"
                required #name="ngModel" />
            <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger text-xs">
                {{"Name is required." | titlecase}}
            </div>
        </div>
        <div class="flex flex-col gap-2">
            <label for="description" class="text-sm font-medium">
                Description
            </label>
            <textarea id="description" [(ngModel)]="selectedTag.description" placeholder="Enter description"
                autocomplete="off" rows="3"
                class="w-full border border-gray-300 rounded-base px-3 py-2 text-sm focus:outline-none focus:border-orange-500"></textarea>
        </div>
    </div>
    }
</ng-template>

@if(editConfirmationDialogForEditingTagsOfExistingProject){
<app-dialog [(visible)]="editConfirmationDialogForEditingTagsOfExistingProject" [style]="{width: '50vw'}"
    [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <div class="font-bold">Editing this tag type will update all projects that are linked to this tag type.</div>
    </ng-template>
    <ng-template #bodyTemplate>
        <p class="text-sm font-medium">
            Are you sure you want to edit this tag type?
        </p>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="outlined" severity="contrast" label="Cancel"
                (clicked)="editConfirmationDialogForEditingTagsOfExistingProject = false" [enableThrottle]="true" />
            <app-button variant="filled" severity="primary" label="Yes" (clicked)="editTagsOfExistingProject()"
                [enableThrottle]="true" />
        </div>
    </ng-template>
</app-dialog>
}

<app-file-selection [(visible)]="fetchFromRepoVisible" [config]="repoFileSelectionConfig" [fetch]="fetchRepoTags"
    [fileItemTemplate]="repoItemTemplate" [selectedFileTemplate]="repoSelectedTemplate"
    (onSubmit)="submitTagsSelection($event)">

    <ng-template #repoItemTemplate let-file let-selected="selected" let-toggleSelection="toggleSelection">
        <div class="flex flex-row items-center gap-3">
            <app-checkbox [value]="selected" (onChange)="toggleSelection($event)" [config]="{ binary: true }" />
            <span class="text-sm text-gray-900">{{ file.name }}</span>
        </div>
    </ng-template>

    <ng-template #repoSelectedTemplate let-file let-toggleSelection="toggleSelection">
        <div class="flex items-center justify-between">
            <span class="text-sm text-gray-900">{{ file.name }}</span>
            <app-button variant="outlined" severity="danger" icon="pi pi-trash" size="sm"
                (clicked)="toggleSelection({ checked: false })" />
        </div>
    </ng-template>
</app-file-selection>

<app-excel-upload-dialog [visible]="uploadExcelDialogVisible" (downloadSampleExcelClicked)="downloadSampleExcel()"
    (onDialogClose)="onExcelDialogClose()" (onExcelUpload)="uploadExcel($event)"
    [showUploadOptions]="true"></app-excel-upload-dialog>
<app-excel-upload-dialog [visible]="uploadTagsExcelDialogVisible"
    (downloadSampleExcelClicked)="downloadTagsSampleExcel()" (onDialogClose)="onTagsExcelDialogClose()"
    (onExcelUpload)="uploadTagsExcel($event)" [showUploadOptions]="false"></app-excel-upload-dialog>
